import Budget from '@/types/purchaseRequest/budget'
import { BaseService } from './../../base'
export class BudgetService extends BaseService<Budget>() {
    static get entity (): string {
        return 'budget'
    }
    static get responseName (): string {
        return 'budget'
    }
}